import { ITopUp } from "../schemas/entity_set";
import { IModelService, IModelQuery, IRequestResult } from "../schemas/structure"
import { PartialViews, AppControllers, AngularServices, AppServices } from '../helpers/config_keys';

interface ITopUpRequest {

}
interface ITopUpQuery extends IModelQuery {

}

interface ITopUpService extends IModelService<ITopUp> {
    query(params: ITopUpQuery): angular.IPromise<IRequestResult<Array<ITopUp>>>
    getAccountInfo(apiKey: string): angular.IPromise<IRequestResult<any>>
    makeRequest(request: ITopUpRequest): angular.IPromise<IRequestResult<string>>
}

class TopUpService implements ITopUpService {

    static $inject = [AngularServices.Q, AngularServices.Http, AppServices.BaseApi, AngularServices.UibModal];

    constructor(private $q: angular.IQService,
        private $http: angular.IHttpService,
        private baseUrl: string,
        private $uibModal: angular.ui.bootstrap.IModalService) { }

    get() {
        let defer = this.$q.defer<IRequestResult<ITopUp[]>>()
        this.$http.get(`${this.baseUrl}/TopUp`).then((response: IRequestResult<Array<ITopUp>>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    getAccountInfo(apikey: string) {
        let defer = this.$q.defer<IRequestResult<any>>()
        this.$http.get(`${this.baseUrl}/appaccount/info?apikey=${apikey}`).then((response: IRequestResult<any>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    find(id: number) {
        let defer = this.$q.defer<IRequestResult<ITopUp>>()
        this.$http.get(`${this.baseUrl}/TopUp?id=${id}`).then((response: IRequestResult<ITopUp>) => {
            defer.resolve(response)
        })
        return defer.promise
    }


    query(params: ITopUpQuery) {
        let defer = this.$q.defer<IRequestResult<ITopUp[]>>()
        this.$http.post(`${this.baseUrl}/TopUp/query`, params).then((response: IRequestResult<Array<ITopUp>>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    makeRequest(request: ITopUpRequest) {
        let defer = this.$q.defer<IRequestResult<string>>()
        this.$http.post(`${this.baseUrl}/appaccount/topuprequest`, request).then((response: IRequestResult<string>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    save(TopUp: ITopUp) {
        let defer = this.$q.defer<IRequestResult<ITopUp>>()
        if (TopUp.id) {
            this.$http.put(`${this.baseUrl}/TopUp`, TopUp).then((response: IRequestResult<ITopUp>) => {
                defer.resolve(response)
            })
        } else {
            this.$http.post(`${this.baseUrl}/TopUp`, TopUp).then((response: IRequestResult<ITopUp>) => {
                defer.resolve(response)
            })
        }
        return defer.promise
    }

    delete(id: number) {
        let defer = this.$q.defer<IRequestResult<ITopUp>>()
        this.$http.delete(`${this.baseUrl}/TopUp?id=${id}`).then((response: IRequestResult<ITopUp>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

}

export { TopUpService, ITopUpService, ITopUpQuery }


// WEBPACK FOOTER //
// ./app/topup/topup_service.ts